// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1jnNs","image":"Header_image__1c2xc","name":"Header_name__3BZDt","info":"Header_info__3rPvS","infoRow":"Header_infoRow__xwPIT"};